import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AcademicAssistantUI from "./AcademicAssistant";
import StatsPage from "./StatsPage";
import AdminDashboard from "./AdminDashboard"; 
import "./fonts.css";


function App() { 
  return (
    <BrowserRouter>
      <Routes>
        {/* Main Tutor App */}
        <Route path="/" element={<AcademicAssistantUI />} />

        {/* Public stats pages */}
        <Route path="/stats/today" element={<StatsPage type="today" />} />
        <Route path="/stats/cost" element={<StatsPage type="cost" />} />

        {/* Internal secured dashboard */}
        <Route
          path="/_internal/usage-dashboard"
          element={<AdminDashboard />}
        />
      
        {/* Optional future route */}
        {/* <Route path="/entertainment" element={<AgniEntertainmentPage />} /> */}
      </Routes>
      
    </BrowserRouter>
  );
}

export default App;
